import { CardBody, Icon } from "@dgs/core";
import { FC, ReactNode } from "react";
import styled from "styled-components";

interface Props {
	warning: ReactNode;
	actions?: ReactNode;
	className?: string;
	hasIcon?: boolean;
}

const WarningIcon = styled(Icon)`
	height: 1.25rem;
	width: 1.25rem;
`;

const WarningCard = styled(CardBody)`
	grid-column: span 2;
	background-color: ${({ theme }) => theme.colors.palette.warning.main.base};
`;

const StyledCardBody = styled(CardBody)`
	display: grid;
	grid-template-columns: max-content 1fr max-content;
	gap: ${({ theme }) => theme.spacing(2)};
	padding: 0;
	align-items: center;
`;

const WarningBannerActions = styled.div`
	display: flex;
	gap: ${({ theme }) => theme.spacing(2)};
	align-items: center;
`;

export const WarningBanner: FC<Props> = ({ className, warning, hasIcon = true, actions = null }) => {
	return (
		<WarningCard className={className}>
			<StyledCardBody>
				{hasIcon ? <WarningIcon $icon="warning" /> : <div />}
				{warning}
				<WarningBannerActions>{actions}</WarningBannerActions>
			</StyledCardBody>
		</WarningCard>
	);
};
